import React, { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import commoncss from "../../css/common.module.css";
import { ReactComponent as PlusIcon } from "../../assets/icons/AddPlus.svg";
import { ReactComponent as CirclePlus } from "../../assets/icons/circlePlus.svg";
import { ReactComponent as AddEditor } from "../../assets/icons/addEditor.svg";
import { ReactComponent as AddTable } from "../../assets/icons/addTable.svg";
import libcss from "../../css/library.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MenuIcon from "../../assets/icons/Menu.png";
import {
  createGeneralNotesApiHandler,
  createGeneralSubNotesApiHandler,
  createBSNotesApiHandler,
  createBSSubNotesApiHandler,
  createPLNotesApiHandler,
  createPLSubNotesApiHandler,
  updateBSNotesApiHandler,
  updateGeneralNotesApiHandler,
  updatePLNotesApiHandler,
  getTemplateDetailsApiHandler,
  updateSubGeneralNotesApiHandler,
  updateSubBSNotesApiHandler,
  updateSubPLNotesApiHandler,
  deleteGeneralNotesApiHandler,
  deleteSubGeneralNotesApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import DeletePopup from "../../elements/DeletePopup";
import { ReactComponent as DelIcon } from "../../../myfin_v2/assets/icons/delete_red.svg";

import TemplateTableGenerator from "./TemplateTableGenerator";
import QuillReactEditor from "../../components/QuillReactEditor";



const genId = () => Math.random().toString(36).slice(2);

const normalizeFromInitial = (initialDoc) => {
  const items = [];
  (initialDoc?.data || []).forEach((block) => {
    if (block.dataType === "text") {
      items.push({
        id: genId(),
        type: "text",
        dataType: "text",
        textFormat: "html",
        textRaw: block?.textRaw ?? " ",
        textPlain: block?.textPlain ?? " ",
        text: [
          {
            id: genId(),
            content: block?.textRaw ?? " ",
          },
        ],
      });
    } else if (block.dataType === "table") {
      items.push({
        id: genId(),
        type: "table",
        tableTitle: block.tableTitle || "Untitled Table",
        tableRow: Array.isArray(block.tableRow)
          ? block.tableRow.map((r) => ({ ...r }))
          : [],
        tableColumn: Array.isArray(block.tableColumn)
          ? block.tableColumn.map((c) => ({ ...c }))
          : [],
        tableType: block?.tableType ?? "table",
        table: block?.table ?? null,
        hasCellData: block?.tableType === "content",
      });
    }
  });
  return items;
};

const serialize = (name, items) => {
  const data = items.map((it) => {

    if (it.type === "text") {
      return {
        dataType: "text",
        text: [
          {
            content: it?.textRaw || " ",
          },
        ],
      };
    }

    if (it.type === "table") {
      const hasCellData =
        it.hasCellData !== undefined
          ? it.hasCellData
          : (it.tableType === "content" || (Array.isArray(it.table) && it.table.length > 0));

      const tableObj = {
        dataType: "table",
        tableTitle: it.tableTitle || "Untitled Table",
        tableRow: (it.tableRow || []).map((row) => ({
          name: row.name,
          lineType: row.lineType,

          ...(row.formulaType && {
            formulaType: row.formulaType,
          }),

          ...(row.isBold !== undefined && {
            isBold: row.isBold,
          }),

          ...(row.lineType === "formula" && {
            formula: row.formula || [],
          }),
        })),
        tableColumn: (it.tableColumn || []).map((col) => ({
          name: col.name,
          lineType: col.lineType,
          ...(col.lineType === "formula" && {
            formula: col.formula || [],
          }),
        })),
      };

      if (hasCellData) {
        tableObj.tableType = "content";
        tableObj.table = it.tableData || it.table || [];
      }

      return tableObj;
    }

    return it;
  });

  return {
    name: name?.trim() || "Untitled",
    data,
  };
};

const removeIdsAndFormulas = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeIdsAndFormulas(item));
  }

  if (typeof obj === "object" && obj !== null) {
    const newObj = {};

    Object.keys(obj).forEach((key) => {
      if (key === "_id" || key === "formula") {
        return;
      }
      // if (key === "_id") {
      //     return;
      // }
      newObj[key] = removeIdsAndFormulas(obj[key]);
    });

    return newObj;
  }

  return obj;
};

export default function Note({
  tempId,
  setHandleSave,
  handleSave,
  isReadOnly = false,
}) {
  const [name, setName] = useState("");
  const [items, setItems] = useState(() => normalizeFromInitial(null));
  const [output, setOutput] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);
  const [isSubEditing, setIsSubEditing] = useState(false);
  const [editingSubId, setEditingSubId] = useState(null);
  const [editingParentId, setEditingParentId] = useState(null);
  const [isEditingbs, setIsEditingbs] = useState(false);
  const [editingIdbs, setEditingIdbs] = useState(null);
  const [isEditingpl, setIsEditingpl] = useState(false);
  const [editingIdpl, setEditingIdpl] = useState(null);
  const [isAddingTable, setIsAddingTable] = useState(false);

  const handleAddParagraph = () => {
    setItems((prev) => [
      ...prev,
      {
        id: genId(),
        type: "text",
        text: [{ id: genId(), content: "" }],
        textFormat: "html",
        textRaw: " ",
        textPlain: " ",
      },
    ]);
  };

  const handleAddTable = () => {
    setIsAddingTable(true);
  };

  const removeItem = (id) => {
    const target = items.find((it) => it.id === id);
    if (!target) return;

    if (!templateData?._id || !selNoteId) {
      swal("Error", "Template data not loaded yet", "error");
      return;
    }

    setDeleteConfirm({
      title: "Are you sure?",
      message: "This item will be deleted permanently",
      onConfirm: () => {
        setDeleteConfirm(null);
        const filteredItems = items.filter((it) => it.id !== id);
        const payload = removeIdsAndFormulas(serialize(name, filteredItems));

        let apiCall;
        if (selNote === "general_sn") {
          apiCall = updateSubGeneralNotesApiHandler(
            {
              groupingTemplateID: templateData._id,
              generalNoteID: selParentId,
              subNoteID: selNoteId,
            },
            payload
          );
        } else if (selNote === "bs_sn") {
          apiCall = updateSubBSNotesApiHandler(
            {
              groupingTemplateID: templateData._id,
              BSNoteID: selParentId,
              subNoteID: selNoteId,
            },
            payload
          );
        } else if (selNote === "pl_sn") {
          apiCall = updateSubPLNotesApiHandler(
            {
              groupingTemplateID: templateData._id,
              PLNoteID: selParentId,
              subNoteID: selNoteId,
            },
            payload
          );
        } else if (selNote === "general") {
          apiCall = updateGeneralNotesApiHandler(
            { groupingTemplateID: templateData._id, generalNoteID: selNoteId },
            payload
          );
        } else if (selNote === "bs") {
          apiCall = updateBSNotesApiHandler(
            { groupingTemplateID: templateData._id, BSNoteID: selNoteId },
            payload
          );
        } else if (selNote === "pl") {
          apiCall = updatePLNotesApiHandler(
            { groupingTemplateID: templateData._id, PLNoteID: selNoteId },
            payload
          );
        } else {
          swal("Error", "Nothing selected to delete from", "error");
          return;
        }

        apiCall
          .then((response) => {
            if (response?.data?.success === true) {
              setItems(filteredItems);
              swal("Successfully deleted", "", "success");
              getTemplateDetails();
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to delete the item",
                "error"
              );
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error ||
                error?.message ||
                "Unable to delete the item",
              "error"
            );
          });
      }
    });
  };

  const updateEditorContent = (id, html) => {
    setItems((prev) =>
      prev.map((it) =>
        it.id === id
          ? {
              ...it,
              text: [{ id: it.text?.[0]?.id ?? genId(), content: html }],
              textFormat: "html",
              textRaw: html.html,
              textPlain: html.text,
            }
          : it,
      ),
    );
  };

  const updateTableItem = (id, patch) => {
    setItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, ...patch } : it))
    );
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
    setItems(newItems);
  };

  useEffect(() => {
    setOutput(serialize(name, items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, items]);

  let history = useHistory();
  const dispatch = useDispatch();
  const [libraryName, setLibraryName] = useState("ST Library");
  const [activeItem, setActiveItem] = useState(null);
  const [selNote, setSelNote] = useState(null);
  const [selNoteId, setSelNoteId] = useState(null);
  const [selParentId, setSelParentId] = useState(null);
  const [generalNotes, setGeneralNotes] = useState(null);
  const [bsNotes, setBSNotes] = useState(null);
  const [plNotes, setPLNotes] = useState(null);
  const [notes, setNotes] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredIndexbs, setHoveredIndexbs] = useState(null);
  const [hoveredIndexpl, setHoveredIndexpl] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [isComposing, setIsComposing] = useState(false);
  const [isComposingbs, setIsComposingbs] = useState(false);
  const [isComposingpl, setIsComposingpl] = useState(false);
  const [gnName, setGnName] = useState("");
  const [bsName, setBsName] = useState("");
  const [plName, setPlName] = useState("");
  const inputRef = useRef(null);
  const inputRefbs = useRef(null);
  const inputRefpl = useRef(null);

  const getTemplateDetails = () => {
    getTemplateDetailsApiHandler({ groupingTemplateID: tempId })
      .then((response) => {
        if (response?.data?.success === true) {
          let td = response?.data?.groupingTemplate;
          if (td) {
            let noteCounter = 1;
            ['generalNotes', 'BSNotes', 'PLNotes'].forEach(key => {
              if (Array.isArray(td[key])) {
                td[key].forEach(note => {
                  note.notes = noteCounter++;
                });
              }
            });
          }
          setTemplateData(td);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getTemplateDetails();
  }, []);

  useEffect(() => {
    getTemplateDetails();
  }, [activeItem]);

  useEffect(() => {
    if (isComposing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isComposing]);

  useEffect(() => {
    if (isComposingbs && inputRefbs.current) {
      inputRefbs.current.focus();
    }
  }, [isComposingbs]);

  useEffect(() => {
    if (isComposingpl && inputRefpl.current) {
      inputRefpl.current.focus();
    }
  }, [isComposingpl]);

  const handleAddClick = () => {
    setIsComposing(true);
    setGnName("");
  };

  const handleAddClickbs = () => {
    setIsComposingbs(true);
    setBsName("");
  };

  const handleAddClickpl = () => {
    setIsComposingpl(true);
    setPlName("");
  };

  const handleCancel = () => {
    setIsComposing(false);
    setGnName("");
    setIsEditing(false);
    setEditingId(null);
  };

  const handleCancelbs = () => {
    setIsComposingbs(false);
    setBsName("");
    setIsEditingbs(false);
    setEditingIdbs(null);
  };

  const handleCancelpl = () => {
    setIsComposingpl(false);
    setPlName("");
    setIsEditingpl(false);
    setEditingIdpl(null);
  };

  const handlePost = () => {
    const value = gnName.trim();
    if (!value) return;
    setNotes([value, ...notes]);
    setGnName("");
    setIsComposing(false);
  };

  const handlePostbs = () => {
    const value = bsName.trim();
    if (!value) return;
    setNotes([value, ...notes]);
    setBsName("");
    setIsComposingbs(false);
  };

  const handlePostpl = () => {
    const value = plName.trim();
    if (!value) return;
    setNotes([value, ...notes]);
    setPlName("");
    setIsComposingpl(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") addGeneralNotes();
    if (e.key === "Escape") handleCancel();
  };

  const handleKeyDownbs = (e) => {
    if (e.key === "Enter") addBSNotes()();
    if (e.key === "Escape") handleCancelbs();
  };

  const handleKeyDownpl = (e) => {
    if (e.key === "Enter") addPLNotes()();
    if (e.key === "Escape") handleCancelpl();
  };

  const [subComposeFor, setSubComposeFor] = useState(null);
  const [subNoteName, setSubNoteName] = useState("");
  const subInputRef = useRef(null);

  const [subComposeForbs, setSubComposeForbs] = useState(null);
  const [subNoteNamebs, setSubNoteNamebs] = useState("");
  const subInputRefbs = useRef(null);

  const [subComposeForpl, setSubComposeForpl] = useState(null);
  const [subNoteNamepl, setSubNoteNamepl] = useState("");
  const subInputRefpl = useRef(null);

  useEffect(() => {
    if (subComposeFor !== null && subInputRef.current) {
      subInputRef.current.focus();
    }
  }, [subComposeFor]);

  useEffect(() => {
    if (subComposeForbs !== null && subInputRefbs.current) {
      subInputRefbs.current.focus();
    }
  }, [subComposeForbs]);

  useEffect(() => {
    if (subComposeForpl !== null && subInputRefpl.current) {
      subInputRefpl.current.focus();
    }
  }, [subComposeForpl]);

  const openSubComposer = (noteIndex) => {
    setSubComposeFor(noteIndex);
    setSubNoteName("");
  };

  const openSubComposerbs = (noteIndex) => {
    setSubComposeForbs(noteIndex);
    setSubNoteNamebs("");
  };

  const openSubComposerpl = (noteIndex) => {
    setSubComposeForpl(noteIndex);
    setSubNoteNamepl("");
  };

  const cancelSubComposer = () => {
    setSubComposeFor(null);
    setSubNoteName("");
    setIsSubEditing(false);
    setEditingSubId(null);
    setEditingParentId(null);
  };

  const cancelSubComposerbs = () => {
    setSubComposeForbs(null);
    setSubNoteNamebs("");
  };

  const cancelSubComposerpl = () => {
    setSubComposeForpl(null);
    setSubNoteNamepl("");
  };

  const postSubnote = () => {
    const value = subNoteName.trim();
    if (!value || subComposeFor === null) return;
    setGeneralNotes((prev) => {
      const next = [...prev];
      const target = { ...next[subComposeFor] };
      const subNotes = Array.isArray(target.subNotes)
        ? [...target.subNotes]
        : [];
      subNotes.push({ name: value });
      target.subNotes = subNotes;
      next[subComposeFor] = target;
      return next;
    });
    setSubNoteName("");
    setSubComposeFor(null);
  };

  const postSubnotebs = () => {
    const value = subNoteNamebs.trim();
    if (!value || subComposeForbs === null) return;
    setBSNotes((prev) => {
      const next = [...prev];
      const target = { ...next[subComposeForbs] };
      const subNotes = Array.isArray(target.subNotes)
        ? [...target.subNotes]
        : [];
      subNotes.push({ name: value });
      target.subNotes = subNotes;
      next[subComposeForbs] = target;
      return next;
    });
    setSubNoteNamebs("");
    setSubComposeForbs(null);
  };

  const postSubnotepl = () => {
    const value = subNoteNamepl.trim();
    if (!value || subComposeForpl === null) return;
    setPLNotes((prev) => {
      const next = [...prev];
      const target = { ...next[subComposeForpl] };
      const subNotes = Array.isArray(target.subNotes)
        ? [...target.subNotes]
        : [];
      subNotes.push({ name: value });
      target.subNotes = subNotes;
      next[subComposeForpl] = target;
      return next;
    });
    setSubNoteNamepl("");
    setSubComposeForpl(null);
  };

  const addGeneralSubNotes = (note_id) => {
    const value = subNoteName.trim();
    if (!value) return;

    const payload = { name: subNoteName };

    if (isSubEditing) {
      updateSubGeneralNotesApiHandler(
        {
          groupingTemplateID: tempId,
          generalNoteID: editingParentId,
          subNoteID: editingSubId,
        },
        payload,
      ).then(() => {
        setIsSubEditing(false);
        setEditingSubId(null);
        setEditingParentId(null);
        setSubNoteName("");
        setSubComposeFor(null);
        getTemplateDetails();
      });
    } else {
      createGeneralSubNotesApiHandler(
        { groupingTemplateID: tempId, generalNoteID: note_id },
        payload,
      ).then((response) => {
        if (response?.data?.success) {
          setSubNoteName("");
          setSubComposeFor(null);
          setGeneralNotes(response?.data?.updatedGroupingTemplate?.generalNotes);
        }
      });
    }
  };

  const addBSSubNotes = (note_id) => {
    const value = subNoteNamebs.trim();
    if (!value) return;

    const bsPayload = { name: subNoteNamebs };
    createBSSubNotesApiHandler(
      { groupingTemplateID: tempId, BSNoteID: note_id },
      bsPayload,
    )
      .then((response) => {
        if (response?.data?.success === true) {
          setSubNoteNamebs("");
          setSubComposeForbs(null);
          setBSNotes(response?.data?.updatedGroupingTemplate?.BSNotes);
        }
      })
      .catch((error) => {});
  };

  const addPLSubNotes = (note_id) => {
    const value = subNoteNamepl.trim();
    if (!value) return;

    const plPayload = { name: subNoteNamepl };
    createPLSubNotesApiHandler(
      { groupingTemplateID: tempId, PLNoteID: note_id },
      plPayload,
    )
      .then((response) => {
        if (response?.data?.success === true) {
          setSubNoteNamepl("");
          setSubComposeForpl(null);
          setPLNotes(response?.data?.updatedGroupingTemplate?.PLNotes);
        }
      })
      .catch((error) => {});
  };

  const handleSubKeyDown = (e) => {
    if (e.key === "Enter") postSubnote();
    if (e.key === "Escape") cancelSubComposer();
  };

  const handleSubKeyDownbs = (e) => {
    if (e.key === "Enter") postSubnotebs();
    if (e.key === "Escape") cancelSubComposerbs();
  };

  const handleSubKeyDownpl = (e) => {
    if (e.key === "Enter") postSubnotepl();
    if (e.key === "Escape") cancelSubComposerpl();
  };

  const breadcrumbItems = [
    {
      label: "Template Library",
      link: `/preview`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `${libraryName}`, link: "", className: "headerLable" },
  ];

  useEffect(() => {
    if (handleSave !== "notes") return;

    setHandleSave(null);

    if (!templateData) {
      swal("Error", "Template data not loaded yet", "error");
      return;
    }

    const payload = removeIdsAndFormulas(output);

    const handleApiError = (err, defaultMsg) => {
      const msg = err?.response?.data?.error || defaultMsg;
      swal("Error", msg, "error");
    };

    if (selNote === "general_sn") {
      updateSubGeneralNotesApiHandler(
        {
          groupingTemplateID: templateData._id,
          generalNoteID: selParentId,
          subNoteID: selNoteId,
        },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("General subnote updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update general subnote",
              "error",
            );
          }
        })
        .catch((error) =>
          handleApiError(error, "Unable to update general subnote"),
        );
      return;
    }

    if (selNote === "bs_sn") {
      updateSubBSNotesApiHandler(
        {
          groupingTemplateID: templateData._id,
          BSNoteID: selParentId,
          subNoteID: selNoteId,
        },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Balance sheet subnote updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update balance sheet subnote",
              "error",
            );
          }
        })
        .catch((error) =>
          handleApiError(error, "Unable to update balance sheet subnote"),
        );
      return;
    }

    if (selNote === "pl_sn") {
      updateSubPLNotesApiHandler(
        {
          groupingTemplateID: templateData._id,
          PLNoteID: selParentId,
          subNoteID: selNoteId,
        },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("P&L subnote updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update P&L subnote",
              "error",
            );
          }
        })
        .catch((error) =>
          handleApiError(error, "Unable to update P&L subnote"),
        );
      return;
    }

    if (selNote === "general") {
      updateGeneralNotesApiHandler(
        { groupingTemplateID: templateData._id, generalNoteID: selNoteId },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("General notes updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update general notes",
              "error",
            );
          }
        })
        .catch((error) =>
          handleApiError(error, "Unable to update general notes"),
        );
      return;
    }

    if (selNote === "bs") {
      updateBSNotesApiHandler(
        { groupingTemplateID: templateData._id, BSNoteID: selNoteId },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Balance sheet notes updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update balance sheet notes",
              "error",
            );
          }
        })
        .catch((error) =>
          handleApiError(error, "Unable to update balance sheet notes"),
        );
      return;
    }

    if (selNote === "pl") {
      updatePLNotesApiHandler(
        { groupingTemplateID: templateData._id, PLNoteID: selNoteId },
        payload,
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("P&L notes updated successfully", "", "success");
            getTemplateDetails();
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update P&L notes",
              "error",
            );
          }
        })
        .catch((error) => handleApiError(error, "Unable to update P&L notes"));
      return;
    }

    swal("Error", "Nothing selected to save", "error");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleSave]);

  useEffect(() => {
    setGeneralNotes(templateData?.generalNotes);
    setBSNotes(templateData?.BSNotes);
    setPLNotes(templateData?.PLNotes);
  }, [templateData]);

  useEffect(() => {
  if (
    templateData?.generalNotes?.length > 0 &&
    !selNote
  ) {
    const firstNote = templateData.generalNotes[0];

    setItems(normalizeFromInitial(firstNote));
    setActiveItem(`gs_0`);
    setSelNote("general");
    setSelNoteId(firstNote._id);
    setSelParentId(null);
    setOutput(firstNote);
    setName(firstNote.name);
  }
}, [templateData, selNote]);

  const addGeneralNotes = () => {
    const value = gnName.trim();
    if (!value) return;

    const payload = { name: gnName };

    if (isEditing) {
      updateGeneralNotesApiHandler(
        {
          groupingTemplateID: tempId,
          generalNoteID: editingId,
        },
        payload,
      ).then(() => {
        setIsEditing(false);
        setEditingId(null);
        setGnName("");
        setIsComposing(false);
        getTemplateDetails();
      });
    } else {
      createGeneralNotesApiHandler({ groupingTemplateID: tempId }, payload).then(
        (res) => {
          setGnName("");
          setIsComposing(false);
          setGeneralNotes(res?.data?.updatedGroupingTemplate?.generalNotes);
        },
      );
    }
  };

  // const addBSNotes = () => {
  //   const value = bsName.trim();
  //   if (!value) return;

  //   const bsNotesPayload = { name: bsName };
  //   createBSNotesApiHandler({ groupingTemplateID: tempId }, bsNotesPayload)
  //     .then((response) => {
  //       if (response?.data?.success === true) {
  //         setBsName("");
  //         setIsComposingbs(false);
  //         setBSNotes(response?.data?.updatedGroupingTemplate?.BSNotes);
  //       }
  //     })
  //     .catch((error) => {});
  // };
  const addBSNotes = () => {
  const value = bsName.trim();
  if (!value) return;

  const bsNotesPayload = { name: bsName };

  if (isEditingbs) {
    updateBSNotesApiHandler(
      { groupingTemplateID: tempId, BSNoteID: editingIdbs },
      bsNotesPayload,
    ).then(() => {
      setIsEditingbs(false);
      setEditingIdbs(null);
      setBsName("");
      setIsComposingbs(false);
      getTemplateDetails();
    });
  } else {
    createBSNotesApiHandler({ groupingTemplateID: tempId }, bsNotesPayload)
      .then((response) => {
        if (response?.data?.success === true) {
          setBsName("");
          setIsComposingbs(false);
          setBSNotes(response?.data?.updatedGroupingTemplate?.BSNotes);
        }
      })
      .catch((error) => {});
  }
};
  // const addPLNotes = () => {
  //   const value = plName.trim();
  //   if (!value) return;

  //   const plNotesPayload = { name: plName };
  //   createPLNotesApiHandler({ groupingTemplateID: tempId }, plNotesPayload)
  //     .then((response) => {
  //       if (response?.data?.success === true) {
  //         setPlName("");
  //         setIsComposingpl(false);
  //         setPLNotes(response?.data?.updatedGroupingTemplate?.PLNotes);
  //       }
  //     })
  //     .catch((error) => {});
  // };
  const addPLNotes = () => {
  const value = plName.trim();
  if (!value) return;

  const plNotesPayload = { name: plName };

  if (isEditingpl) {
    updatePLNotesApiHandler(
      { groupingTemplateID: tempId, PLNoteID: editingIdpl },
      plNotesPayload,
    ).then(() => {
      setIsEditingpl(false);
      setEditingIdpl(null);
      setPlName("");
      setIsComposingpl(false);
      getTemplateDetails();
    });
  } else {
    createPLNotesApiHandler({ groupingTemplateID: tempId }, plNotesPayload)
      .then((response) => {
        if (response?.data?.success === true) {
          setPlName("");
          setIsComposingpl(false);
          setPLNotes(response?.data?.updatedGroupingTemplate?.PLNotes);
        }
      })
      .catch((error) => {});
  }
};
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // ─── General Notes drag handler (mirrors BS / PL pattern) ───────────────────
  const onDragEndGN = (result) => {
    if (!result.destination) return;

    const { source, destination, type } = result;

    // Reorder top-level General Notes
    if (type === "GN_NOTE") {
      const updated = reorder(generalNotes, source.index, destination.index);
      setGeneralNotes(updated);
    }

    // Reorder General Notes sub-notes
    if (type === "GN_SUB_NOTE") {
      const parentIndex = Number(source.droppableId.split("-")[1]);
      const parent = generalNotes[parentIndex];

      const updatedSubNotes = reorder(
        parent.subNotes,
        source.index,
        destination.index,
      );

      const updatedNotes = [...generalNotes];
      updatedNotes[parentIndex] = {
        ...parent,
        subNotes: updatedSubNotes,
      };

      setGeneralNotes(updatedNotes);
    }
  };
  // ────────────────────────────────────────────────────────────────────────────

  const onDragEndBS = (result) => {
    if (!result.destination) return;

    const { source, destination, type } = result;

    if (type === "BS_NOTE") {
      const updated = reorder(bsNotes, source.index, destination.index);
      setBSNotes(updated);
    }

    if (type === "BS_SUB_NOTE") {
      const parentIndex = Number(source.droppableId.split("-")[1]);
      const parent = bsNotes[parentIndex];

      const updatedSubNotes = reorder(
        parent.subNotes,
        source.index,
        destination.index,
      );

      const updatedNotes = [...bsNotes];
      updatedNotes[parentIndex] = {
        ...parent,
        subNotes: updatedSubNotes,
      };

      setBSNotes(updatedNotes);
    }
  };

  const onDragEndPL = (result) => {
    if (!result.destination) return;

    const { source, destination, type } = result;

    if (type === "PL_NOTE") {
      const updated = reorder(plNotes, source.index, destination.index);
      setPLNotes(updated);
    }

    if (type === "PL_SUB_NOTE") {
      const parentIndex = Number(source.droppableId.split("-")[1]);
      const parent = plNotes[parentIndex];

      const updatedSubNotes = reorder(
        parent.subNotes,
        source.index,
        destination.index,
      );

      const updatedNotes = [...plNotes];
      updatedNotes[parentIndex] = {
        ...parent,
        subNotes: updatedSubNotes,
      };

      setPLNotes(updatedNotes);
    }
  };

  const resetItems = () => {
    setItems(normalizeFromInitial(null));
    setActiveItem(null);
    setSelNote(null);
    setSelNoteId(null);
    setSelParentId(null);
  };

  const deleteGNNoteHandler = (id) => {
    setDeleteConfirm({
      title: "Confirm deletion of note data?",
      message: "Once deleted, you will not be able to recover this!",
      onConfirm: () => {
        setDeleteConfirm(null);
        deleteGeneralNotesApiHandler({
          groupingTemplateID: tempId,
          generalNoteID: id,
        })
          .then((response) => {
            if (response?.data?.success === true) {
              setGeneralNotes(null);
              resetItems();
              getTemplateDetails();
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to delete the data",
              "error",
            );
          });
      }
    });
  };

  const deleteGNSubNoteHandler = (id, subid) => {
    setDeleteConfirm({
      title: "Confirm deletion of note data?",
      message: "Once deleted, you will not be able to recover this!",
      onConfirm: () => {
        setDeleteConfirm(null);
        deleteSubGeneralNotesApiHandler({
          groupingTemplateID: tempId,
          generalNoteID: id,
          subNoteID: subid,
        })
          .then((response) => {
            if (response?.data?.success === true) {
              setGeneralNotes(null);
              resetItems();
              getTemplateDetails();
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to delete the data",
              "error",
            );
          });
      }
    });
  };

  return (
    <>
      <motion.div
        initial={{ x: 500, y: 500, opacity: 0 }}
        animate={{ x: 0, y: 0, opacity: 1 }}
        exit={{ x: 0, y: 0, opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }}
        className={libcss.hierarchyLayout}
        style={{ border: "0px", gridGap: "0", paddingTop: "15px", paddingBottom: "45px", paddingLeft: "0px", paddingRight: "5px", gap: "10px" }}
      >
        <div
          className={`${libcss.notesSec} ${commoncss.hideScroll}`}
          style={{ width: "40%", paddingBottom: "10px" }}
        >
          <div className={libcss.levelCatDiv}>

            {/* ═══════════════════════════════════════════════
                GENERAL NOTES  — now with full DnD support
            ════════════════════════════════════════════════ */}
            <div className={libcss.levelCat}>
              <span className={libcss.notesLabel}>
                <span>General Notes</span>
                {!isReadOnly && (
                  <span
                    className={libcss.addNoteLabel}
                    onClick={handleAddClick}
                    style={{ cursor: "pointer" }}
                  >
                    <PlusIcon  height={15} width={15} style={{ marginTop: "-1px"}} /> Add Note
                  </span>
                )}
              </span>

              <div className={`${libcss.levelCatDiv} ${libcss.notesDiv}`}>
                {/* Composer for new top-level GN note */}
                {isComposing && !isEditing && !isReadOnly && (
                  <div className={libcss.notesItem}>
                    <input
                      ref={inputRef}
                      value={gnName}
                      onChange={(e) => setGnName(e.target.value)}
                      onKeyDown={handleKeyDown}
                      placeholder="Type your note..."
                      className={libcss.noteInput}
                    />
                    <div className={libcss.lineActions1}>
                      <span
                        className={`${commoncss.clickable}`}
                        onClick={addGeneralNotes}
                        disabled={!gnName.trim()}
                        style={{ color: "#205a46", fontWeight: "600", marginTop: "-2px"}}
                      >
                        ADD
                      </span>
                      &ensp;
                      <CloseIcon className={commoncss.clickable} onClick={handleCancel} width={14} height={14} style={{ marginTop: "-2px"}}/>
                    </div>
                  </div>
                )}

                {/* DnD context wrapping GN notes + their subnotes */}
                <DragDropContext onDragEnd={onDragEndGN}>
                  <Droppable droppableId="gn-notes" type="GN_NOTE">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {generalNotes &&
                          generalNotes.map((note, i) => (
                            <Draggable
                              key={note._id}
                              draggableId={note._id}
                              index={i}
                              isDragDisabled={isReadOnly}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  className=""
                                >
                                  {/* ── Top-level GN note ── */}
                                  {isEditing && editingId === note._id ? (
                                    <div className={`my-2 ${libcss.notesItem}`}>
                                      <input
                                        ref={inputRef}
                                        value={gnName}
                                        onChange={(e) => setGnName(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Type your note..."
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions1}>
                                        <span
                                          className={`${commoncss.clickable}`}
                                          onClick={addGeneralNotes}
                                          disabled={!gnName.trim()}
                                          style={{ color: "#205a46", fontWeight: "600", marginTop: "-2px"}}
                                        >
                                          ADD
                                        </span>
                                        &ensp;
                                        <CloseIcon className={commoncss.clickable} onClick={handleCancel} width={14} height={14} style={{ marginTop: "-2px"}}/>
                                      </div>
                                    </div>
                                  ) : (
                                  <div
                                    style={{ position: "relative",  paddingLeft: 20,}} 

                                    className={`my-2 ${
                                      hoveredIndex === i || activeItem === `gs_${i}`
                                        ? libcss.notesItem
                                        : libcss.notesItemView
                                    }`}
                                    onMouseEnter={() => setHoveredIndex(i)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    onClick={() => {
                                      setItems(normalizeFromInitial(note));
                                      setActiveItem(`gs_${i}`);
                                      setSelNote("general");
                                      setSelNoteId(note._id);
                                      setSelParentId(null);
                                      setOutput(note);
                                      setName(note.name);
                                    }}
                                  >
                                    <span
                                      {...provided.dragHandleProps}
                                      style={{
                                        position: "absolute",      
                                        left: 8,                   
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "grab",
                                        transition: "opacity 0.2s ease",
                                        opacity:
                                          hoveredIndex === i || activeItem === `gs_${i}` ? 1 : 0,
                                        pointerEvents:
                                          hoveredIndex === i || activeItem === `gs_${i}` ? "auto" : "none",
                                      }}
                                    >
                                      <img src={MenuIcon} alt="drag"  />
                                    </span>
                                    {note.name}

                                    {(hoveredIndex === i ||
                                      activeItem === `gs_${i}`) && (
                                      <div className={libcss.lineActions1}>
                                        {!isReadOnly && (
                                          <>
                                            <PlusIcon
                                              role="button"
                                              tabIndex={0}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                openSubComposer(i);
                                              }}
                                              style={{
                                                outline: "none",
                                                opacity:
                                                  activeItem === `gs_${i}`
                                                    ? 1
                                                    : 0.5,
                                              }}
                                              onKeyDown={(e) =>
                                                (e.key === "Enter" ||
                                                  e.key === " ") &&
                                                openSubComposer(i)
                                              }
                                            />
                                            &ensp;
                                            <EditIcon
                                              width={15}
                                              height={15}
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setIsComposing(true);
                                                setGnName(note.name);
                                                setEditingId(note._id);
                                                setIsEditing(true);
                                              }}
                                            />
                                            &ensp;
                                            <DelIcon
                                              className={commoncss.clickable}
                                              width={15}
                                              height={15}
                                              onClick={() => {
                                                deleteGNNoteHandler(note._id);
                                              }}
                                            />
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  )}

                                  {/* ── Subnote input composer (ADD ONLY) ── */}
                                  {subComposeFor === i && !isSubEditing && !isReadOnly && (
                                    <div className={libcss.subNotesItemView}>
                                      <input
                                        ref={subInputRef}
                                        value={subNoteName}
                                        onChange={(e) =>
                                          setSubNoteName(e.target.value)
                                        }
                                        onKeyDown={handleSubKeyDown}
                                        placeholder="Type subnote…"
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions1}>
                                        <span
                                          style={{ color: "#205a46" , fontWeight: "600" }}
                                          className={`${commoncss.clickable}`}
                                          onClick={() =>
                                            addGeneralSubNotes(note._id)
                                          }
                                          disabled={!subNoteName.trim()}
                                        >
                                          ADD
                                        </span>
                                        &ensp;
                                        <CloseIcon
                                          className={commoncss.clickable}
                                          onClick={cancelSubComposer}
                                          width={14}
                                          height={14}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* ── Draggable GN sub-notes ── */}
                                  <Droppable
                                    droppableId={`gn-sub-${i}`}
                                    type="GN_SUB_NOTE"
                                  >
                                    {(subProvided) => (
                                      <div
                                        ref={subProvided.innerRef}
                                        {...subProvided.droppableProps}
                                      >
                                        {note?.subNotes?.length > 0 && (
                                           <div className={libcss.subNotesWrapper} style={{ border: "none"}}>
                                            {note.subNotes.map((subnote, j) => {
                                              const subActiveKey = `gs_sn_${i}-${j}`;
                                              const subHoverKey = `g-s-${i}-${j}`;
                                              const isActiveOrHover =
                                                hoveredIndex === subHoverKey ||
                                                activeItem === subActiveKey;

                                              return (
                                                <Draggable
                                                  key={subnote._id}
                                                  draggableId={subnote._id}
                                                  index={j}
                                                    isDragDisabled={isReadOnly}
                                                  >
                                                    {(subDrag) => (
                                                      <div
                                                        ref={subDrag.innerRef}
                                                        {...subDrag.draggableProps}
                                                        {...subDrag.dragHandleProps}
                                                        key={`g-sub-${
                                                          subnote._id ||
                                                          `${i}-${j}`
                                                        }`}
                                                        className={
                                                          isActiveOrHover
                                                            ? libcss.notesItem
                                                            : libcss.subNotesItemView
                                                        }
                                                      style={{
                                                        marginBottom: "4px",
                                                        minHeight: "32px",
                                                        borderLeft: "2px solid #d8e5df",
                                                        paddingLeft: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        ...subDrag.draggableProps.style,
                                                      }}
                                                      onMouseEnter={() =>
                                                        setHoveredIndex(
                                                          subHoverKey,
                                                        )
                                                      }
                                                      onMouseLeave={() =>
                                                        setHoveredIndex(null)
                                                      }
                                                      onClick={() => {
                                                        setItems(
                                                          normalizeFromInitial(
                                                            subnote,
                                                          ),
                                                        );
                                                        setActiveItem(
                                                          subActiveKey,
                                                        );
                                                        setSelNote("general_sn");
                                                        setSelNoteId(
                                                          subnote._id,
                                                        );
                                                        setSelParentId(note._id);
                                                        setOutput(subnote);
                                                        setName(subnote.name);
                                                      }}
                                                    >
                                                        {isSubEditing && editingSubId === subnote._id ? (
                                                          <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                                                            <input
                                                              ref={subInputRef}
                                                              value={subNoteName}
                                                              onChange={(e) =>
                                                                setSubNoteName(e.target.value)
                                                              }
                                                              onKeyDown={handleSubKeyDown}
                                                              placeholder="Type subnote…"
                                                              className={libcss.noteInput}
                                                              style={{ flex: 1 }}
                                                            />
                                                            <div className={libcss.lineActions1}>
                                                              <span
                                                                style={{ color: "#205a46" , fontWeight: "600" }}
                                                                className={`${commoncss.clickable}`}
                                                                onClick={() =>
                                                                  addGeneralSubNotes(note._id)
                                                                }
                                                                disabled={!subNoteName.trim()}
                                                              >
                                                                ADD
                                                              </span>
                                                              &ensp;
                                                              <CloseIcon
                                                                className={commoncss.clickable}
                                                                onClick={(e) => {
                                                                  e.stopPropagation();
                                                                  cancelSubComposer();
                                                                }}
                                                                width={14}
                                                                height={14}
                                                              />
                                                            </div>
                                                          </div>
                                                        ) : (
                                                          <>
                                                            {subnote.name}
                                                            {isActiveOrHover &&
                                                              !isReadOnly && (
                                                                <div
                                                                  className={
                                                                    libcss.lineActions1
                                                                  }
                                                                >
                                                                  <EditIcon
                                                                    width={15}
                                                                    height={15}
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    onClick={(e) => {
                                                                      e.stopPropagation();
                                                                      setIsSubEditing(
                                                                        true,
                                                                      );
                                                                      setSubNoteName(
                                                                        subnote.name,
                                                                      );
                                                                      setEditingSubId(
                                                                        subnote._id,
                                                                      );
                                                                      setEditingParentId(
                                                                        note._id,
                                                                      );
                                                                      setSubComposeFor(
                                                                        i,
                                                                      );
                                                                    }}
                                                                  />
                                                                  &ensp;
                                                                  <CloseIcon
                                                                    className={
                                                                      commoncss.clickable
                                                                    }
                                                                    width={16}
                                                                    height={16}
                                                                    onClick={(e) => {
                                                                      e.stopPropagation();
                                                                      deleteGNSubNoteHandler(
                                                                        note._id,
                                                                        subnote._id,
                                                                      );
                                                                    }}
                                                                  />
                                                                </div>
                                                              )}
                                                          </>
                                                        )}
                                                      </div>
                                                  )}
                                                </Draggable>
                                              );
                                            })}
                                          </div>
                                        )}
                                        {subProvided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>

            {/* ═══════════════════════════════════════════════
                BALANCE SHEET  — unchanged
            ════════════════════════════════════════════════ */}
            <div className={libcss.levelCat}>
              <span className={libcss.notesLabel}>
                <span>Balance Sheet</span>
                {/* {!isReadOnly && (
                  <span
                    className={libcss.addNoteLabel}
                    onClick={handleAddClickbs}
                    style={{ cursor: "pointer" }}
                  >
                    <PlusIcon /> Add Note
                  </span>
                )} */}
              </span>

              <div className={`${libcss.levelCatDiv} ${libcss.notesDiv}`}>
                {isComposingbs && !isEditingbs && !isReadOnly && (
                  <div className={libcss.notesItem}>
                    <input
                      ref={inputRefbs}
                      value={bsName}
                      onChange={(e) => setBsName(e.target.value)}
                      onKeyDown={handleKeyDownbs}
                      placeholder="Type your note..."
                      className={libcss.noteInput}
                    />
                    <div className={libcss.lineActions1}>
                      <span
                        className={`${commoncss.clickable}`}
                        onClick={addBSNotes}
                        disabled={!bsName.trim()}
                      >
                        Add
                      </span>
                      &ensp;
                      <CloseIcon
                        onClick={handleCancelbs}
                        width={14}
                        height={14}
                      />
                    </div>
                  </div>
                )}

                <DragDropContext onDragEnd={onDragEndBS}>
                  <Droppable droppableId="bs-notes" type="BS_NOTE">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {bsNotes &&
                          bsNotes.map((note, i) => (
                            <Draggable
                              key={note._id}
                              draggableId={note._id}
                              index={i}
                              isDragDisabled={true}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                >
                                  {isEditingbs && editingIdbs === note._id ? (
                                    <div className={`my-2 ${libcss.notesItem}`}>
                                      <input
                                        ref={inputRefbs}
                                        value={bsName}
                                        onChange={(e) => setBsName(e.target.value)}
                                        onKeyDown={handleKeyDownbs}
                                        placeholder="Type your note..."
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions1}>
                                        <span
                                          className={`${commoncss.clickable}`}
                                          onClick={addBSNotes}
                                          disabled={!bsName.trim()}
                                          style={{ color: "#205a46", fontWeight: "600", marginTop: "-2px"}}
                                        >
                                          ADD
                                        </span>
                                        &ensp;
                                        <CloseIcon onClick={handleCancelbs} width={14} height={14} style={{ marginTop: "-2px"}}/>
                                      </div>
                                    </div>
                                  ) : (
                                  <div
                                    {...provided.dragHandleProps}
                                    className={`my-2 ${
                                      hoveredIndexbs === i ||
                                      activeItem === `bs_${i}`
                                        ? libcss.notesItem
                                        : libcss.notesItemView
                                    }`}
                                    onMouseEnter={() => setHoveredIndexbs(i)}
                                    onMouseLeave={() => setHoveredIndexbs(null)}
                                    onClick={() => {
                                      setItems(normalizeFromInitial(note));
                                      setActiveItem(`bs_${i}`);
                                      setSelNote("bs");
                                      setSelNoteId(note._id);
                                      setSelParentId(null);
                                      setOutput(note);
                                      setName(note.name);
                                    }}
                                  >
                                    {note.name}

                                    {(hoveredIndexbs === i ||
                                      activeItem === `bs_${i}`) &&
                                      !isReadOnly && (
                                        <div className={libcss.lineActions1}>
                                          {/* <PlusIcon
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              openSubComposerbs(i);
                                            }}
                                          /> */}
                                          &ensp;
                                         <EditIcon
                                          width={15}
                                          height={15}
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setIsComposingbs(true);
                                            setBsName(note.name);
                                            setEditingIdbs(note._id);
                                            setIsEditingbs(true);
                                          }}
                                        />
                                        </div>
                                      )}
                                  </div>
                                  )}

                                  {/* BS sub-note composer */}
                                  {/* {subComposeForbs === i && !isReadOnly && (
                                    <div className={libcss.subNotesItemView}>
                                      <input
                                        ref={subInputRefbs}
                                        value={subNoteNamebs}
                                        onChange={(e) =>
                                          setSubNoteNamebs(e.target.value)
                                        }
                                        onKeyDown={handleSubKeyDownbs}
                                        placeholder="Type subnote…"
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions}>
                                        <span
                                          className={`${commoncss.clickable}`}
                                          onClick={() =>
                                            addBSSubNotes(note._id)
                                          }
                                          disabled={!subNoteNamebs.trim()}
                                        >
                                          Add
                                        </span>
                                        &ensp;
                                        <CloseIcon
                                          onClick={cancelSubComposerbs}
                                          width={14}
                                          height={14}
                                        />
                                      </div>
                                    </div>
                                  )} */}

                                  <Droppable
                                    droppableId={`bs-sub-${i}`}
                                    type="BS_SUB_NOTE"
                                  >
                                    {(subProvided) => (
                                      <div
                                        ref={subProvided.innerRef}
                                        {...subProvided.droppableProps}
                                      >
                                        {note?.subNotes?.map((subnote, j) => {
                                          const subActiveKey = `bs_sn_${i}-${j}`;
                                          const subHoverKey = `b-s-${i}-${j}`;
                                          const isActiveOrHover =
                                            hoveredIndexbs === subHoverKey ||
                                            activeItem === subActiveKey;

                                          return (
                                            <Draggable
                                              key={subnote._id}
                                              draggableId={subnote._id}
                                              index={j}
                                              isDragDisabled={true}
                                            >
                                              {(subDrag) => (
                                                <div
                                                  ref={subDrag.innerRef}
                                                  {...subDrag.draggableProps}
                                                  {...subDrag.dragHandleProps}
                                                  className={`${
                                                    isActiveOrHover
                                                      ? libcss.notesItem
                                                      : libcss.subNotesItemView
                                                  } my-2`}
                                                  onMouseEnter={() =>
                                                    setHoveredIndexbs(
                                                      subHoverKey,
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoveredIndexbs(null)
                                                  }
                                                  onClick={() => {
                                                    setItems(
                                                      normalizeFromInitial(
                                                        subnote,
                                                      ),
                                                    );
                                                    setActiveItem(subActiveKey);
                                                    setSelNote("bs_sn");
                                                    setSelNoteId(subnote._id);
                                                    setSelParentId(note._id);
                                                    setOutput(subnote);
                                                    setName(subnote.name);
                                                  }}
                                                >
                                                  {subnote.name}

                                                  {isActiveOrHover &&
                                                    !isReadOnly && (
                                                      <div
                                                        className={
                                                          libcss.lineActions1
                                                        }
                                                      >
                                                        <EditIcon width={15} height={15} style={{ cursor: "pointer" }}/>
                                                      </div>
                                                    )}
                                                </div>
                                              )}
                                            </Draggable>
                                          );
                                        })}
                                        {subProvided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>

            {/* ═══════════════════════════════════════════════
                P&L  — unchanged
            ════════════════════════════════════════════════ */}
            <div className={libcss.levelCat}>
              <span className={libcss.notesLabel}>
                <span>P&L</span>
                {/* {!isReadOnly && (
                  <span
                    className={libcss.addNoteLabel}
                    onClick={handleAddClickpl}
                    style={{ cursor: "pointer" }}
                  >
                    <PlusIcon /> Add Note
                  </span>
                )} */}
              </span>

              <div className={`${libcss.levelCatDiv} ${libcss.notesDiv}`}>
                {isComposingpl && !isEditingpl && !isReadOnly && (
                  <div className={libcss.notesItem}>
                    <input
                      ref={inputRefpl}
                      value={plName}
                      onChange={(e) => setPlName(e.target.value)}
                      onKeyDown={handleKeyDownpl}
                      placeholder="Type your note..."
                      className={libcss.noteInput}
                    />
                    <div className={libcss.lineActions1}>
                      <span
                        className={`${commoncss.clickable}`}
                        onClick={addPLNotes}
                        disabled={!plName.trim()}
                      >
                        Add
                      </span>
                      &ensp;
                      <CloseIcon
                        onClick={handleCancelpl}
                        width={14}
                        height={14}
                      />
                    </div>
                  </div>
                )}

                <DragDropContext onDragEnd={onDragEndPL}>
                  <Droppable droppableId="pl-notes" type="PL_NOTE">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {plNotes &&
                          plNotes.map((note, i) => (
                            <Draggable
                              key={note._id}
                              draggableId={note._id}
                              index={i}
                              isDragDisabled={true}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                >
                                  {isEditingpl && editingIdpl === note._id ? (
                                    <div className={`my-2 ${libcss.notesItem}`}>
                                      <input
                                        ref={inputRefpl}
                                        value={plName}
                                        onChange={(e) => setPlName(e.target.value)}
                                        onKeyDown={handleKeyDownpl}
                                        placeholder="Type your note..."
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions1}>
                                        <span
                                          className={`${commoncss.clickable}`}
                                          onClick={addPLNotes}
                                          disabled={!plName.trim()}
                                          style={{ color: "#205a46", fontWeight: "600", marginTop: "-2px"}}
                                        >
                                          ADD
                                        </span>
                                        &ensp;
                                        <CloseIcon onClick={handleCancelpl} width={14} height={14} style={{ marginTop: "-2px"}}/>
                                      </div>
                                    </div>
                                  ) : (
                                  <div
                                    {...provided.dragHandleProps}
                                    className={`my-2 ${
                                      hoveredIndexpl === i ||
                                      activeItem === `pl_${i}`
                                        ? libcss.notesItem
                                        : libcss.notesItemView
                                    }`}
                                    onMouseEnter={() => setHoveredIndexpl(i)}
                                    onMouseLeave={() => setHoveredIndexpl(null)}
                                    onClick={() => {
                                      setItems(normalizeFromInitial(note));
                                      setActiveItem(`pl_${i}`);
                                      setSelNote("pl");
                                      setSelNoteId(note._id);
                                      setSelParentId(null);
                                      setOutput(note);
                                      setName(note.name);
                                    }}
                                  >
                                    {note.name}

                                    {(hoveredIndexpl === i ||
                                      activeItem === `pl_${i}`) &&
                                      !isReadOnly && (
                                        <div className={libcss.lineActions1}>
                                          {/* <PlusIcon
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              openSubComposerpl(i);
                                            }}
                                          /> */}
                                          &ensp;
                                          <EditIcon
                                            width={15}
                                            height={15}
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setIsComposingpl(true);
                                              setPlName(note.name);
                                              setEditingIdpl(note._id);
                                              setIsEditingpl(true);
                                            }}
                                          />
                                        </div>
                                      )}
                                  </div>
                                  )}

                                  {/* PL sub-note composer */}
                                  {/* {subComposeForpl === i && !isReadOnly && (
                                    <div className={libcss.subNotesItemView}>
                                      <input
                                        ref={subInputRefpl}
                                        value={subNoteNamepl}
                                        onChange={(e) =>
                                          setSubNoteNamepl(e.target.value)
                                        }
                                        onKeyDown={handleSubKeyDownpl}
                                        placeholder="Type subnote…"
                                        className={libcss.noteInput}
                                      />
                                      <div className={libcss.lineActions}>
                                        <span
                                          className={`${commoncss.clickable}`}
                                          onClick={() =>
                                            addPLSubNotes(note._id)
                                          }
                                          disabled={!subNoteNamepl.trim()}
                                        >
                                          Add
                                        </span>
                                        &ensp;
                                        <CloseIcon
                                          onClick={cancelSubComposerpl}
                                          width={14}
                                          height={14}
                                        />
                                      </div>
                                    </div>
                                  )} */}

                                  <Droppable
                                    droppableId={`pl-sub-${i}`}
                                    type="PL_SUB_NOTE"
                                  >
                                    {(subProvided) => (
                                      <div
                                        ref={subProvided.innerRef}
                                        {...subProvided.droppableProps}
                                      >
                                        {note?.subNotes?.map((subnote, j) => {
                                          const subActiveKey = `pl_sn_${i}-${j}`;
                                          const subHoverKey = `p-s-${i}-${j}`;
                                          const isActiveOrHover =
                                            hoveredIndexpl === subHoverKey ||
                                            activeItem === subActiveKey;

                                          return (
                                            <Draggable
                                              key={subnote._id}
                                              draggableId={subnote._id}
                                              index={j}
                                              isDragDisabled={true}
                                            >
                                              {(subDrag) => (
                                                <div
                                                  ref={subDrag.innerRef}
                                                  {...subDrag.draggableProps}
                                                  {...subDrag.dragHandleProps}
                                                  className={`${
                                                    isActiveOrHover
                                                      ? libcss.notesItem
                                                      : libcss.subNotesItemView
                                                  } my-2`}
                                                  onMouseEnter={() =>
                                                    setHoveredIndexpl(
                                                      subHoverKey,
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoveredIndexpl(null)
                                                  }
                                                  onClick={() => {
                                                    setItems(
                                                      normalizeFromInitial(
                                                        subnote,
                                                      ),
                                                    );
                                                    setActiveItem(subActiveKey);
                                                    setSelNote("pl_sn");
                                                    setSelNoteId(subnote._id);
                                                    setSelParentId(note._id);
                                                    setOutput(subnote);
                                                    setName(subnote.name);
                                                  }}
                                                >
                                                  {subnote.name}

                                                  {isActiveOrHover &&
                                                    !isReadOnly && (
                                                      <div
                                                        className={
                                                          libcss.lineActions1
                                                        }
                                                      >
                                                        <EditIcon
                                                          width={15}
                                                          height={15}
                                                          style={{ cursor: "pointer" }}
                                                        />
                                                      </div>
                                                    )}
                                                </div>
                                              )}
                                            </Draggable>
                                          );
                                        })}
                                        {subProvided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </div>
        </div>

        {/* ── Right panel: editors and tables ── */}
        <div className={`${libcss.dataDivs} ${commoncss.hideScroll}`} style={{ paddingLeft: "5px", paddingRight: "25px", paddingBottom: "10px" }}>
          <div className={libcss.levelCatDiv}>
            <DragDropContext onDragEnd={onDragEndItems}>
              <Droppable droppableId="notes-right-items">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ display: "grid", gap: 20 }}
                  >
                    {items.map((it, idx) => (
                      <Draggable key={it.id} draggableId={it.id} index={idx} isDragDisabled={isReadOnly}>
                        {(dragProvided) => (
                          <div
                            ref={dragProvided.innerRef}
                            {...dragProvided.draggableProps}
                            style={{
                              ...dragProvided.draggableProps.style,
                              width: "1230px",
                            }}
                          >
                            {/* Unified Header - Only for tables */}
                            {it.type === "table" && (
                              <div
                                style={{
                                  background: "#f8f9f9",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "10px 10px",
                                  border: "1px solid #eaeeed",
                                  borderBottom: "none",
                                  borderRadius: "10px 10px 0 0",
                                  gap: "8px",
                                }}
                              >
                                <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                  <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                </div>
                                <span
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "13px",
                                    color: "#205a46",
                                    textTransform: "uppercase",
                                    flex: 1,
                                  }}
                                >
                                  {it.tableTitle || "Table"}
                                </span>
                                {!isReadOnly && (
                                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <EditIcon
                                      style={{ cursor: "pointer", width: 16, height: 16 }}
                                      onClick={() => setForceOpenTableId(it.id)}
                                    />
                                    <DelIcon
                                      style={{ cursor: "pointer", width: 16, height: 16 }}
                                      onClick={() => removeItem(it.id)}
                                    />
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Content Area */}
                            {it.type === "text" ? (
                              <QuillReactEditor
                                value={it.text?.[0]?.content ?? ""}
                                onChange={(content) => {
                                  updateEditorContent(it.id, content);
                                }}
                                disabled={isReadOnly}
                                dragHandleProps={dragProvided.dragHandleProps}
                                rightControl={
                                  !isReadOnly && (
                                    <DelIcon
                                      style={{ cursor: "pointer", width: 16, height: 16, marginRight: 8 }}
                                      onClick={() => removeItem(it.id)}
                                    />
                                  )
                                }
                              />
                            ) : (
                              <div
                                style={{
                                  border: "none",
                                  borderRadius: "0 0 10px 10px",
                                  background: "#fff",
                                  padding: 0,
                                  position: "relative",
                                }}
                              >
                                <TemplateTableGenerator
                                  forceOpen={it.id === forceOpenTableId}
                                  hideRowBoldIcon={selNote?.startsWith("bs") || selNote?.startsWith("pl")}
                                  value={{
                                    tableTitle: it.tableTitle,
                                    tableRow: it.tableRow,
                                    tableColumn: it.tableColumn,
                                    tableType: it.tableType,
                                    table: it.table,
                                    hasCellData: it.hasCellData,
                                  }}
                                  onChange={(next) => {
                                    updateTableItem(it.id, {
                                      tableTitle: next.tableTitle,
                                      tableRow: next.tableRow,
                                      tableColumn: next.tableColumn,
                                      hasCellData: next.hasCellData,
                                      tableData: next.tableData,
                                    });
                                  }}
                                  onAfterOpen={() => {
                                    if (forceOpenTableId === it.id)
                                      setForceOpenTableId(null);
                                  }}
                                  disabled={isReadOnly}
                                  hideHeader={true}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>

            {selNote && !isReadOnly && (
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  padding: 12,
                  borderRadius: 12,
                  marginBottom: 12,
                }}
              >
                <CirclePlus width={37} />
                <AddEditor width={140} onClick={handleAddParagraph} />
                <AddTable width={100} onClick={handleAddTable} />
              </div>
            )}
            {isAddingTable && (
              <TemplateTableGenerator
                forceOpen={true}
                hideRowBoldIcon={selNote?.startsWith("bs") || selNote?.startsWith("pl")}
                value={{}}
                onChange={(next) => {
                  const id = genId();
                  setItems((prev) => [
                    ...prev,
                    {
                      id,
                      type: "table",
                      tableTitle: next.tableTitle,
                      tableRow: next.tableRow,
                      tableColumn: next.tableColumn,
                      hasCellData: next.hasCellData,
                      tableData: next.tableData,
                      tableType: "",
                      table: [],
                    },
                  ]);
                  setIsAddingTable(false);
                }}
                onCancel={() => setIsAddingTable(false)}
              />
            )}
          </div>
        </motion.div>
        <DeletePopup
          isOpen={deleteConfirm !== null}
          title={deleteConfirm?.title}
          message={deleteConfirm?.message}
          onConfirm={deleteConfirm?.onConfirm}
          onCancel={() => setDeleteConfirm(null)}
        />
      </>
    );
  }